export default () => ({
  interests: [],
  isOverlay: false,
  display: false,
  showHeading: true,
  customerId: null,

  initInterest(id) {
    CF.customerReady(
      function () {
        this.interests = CF.customer.get("preference_interests") || [];
        this.customerId = id;
      }.bind(this)
    );
  },

  setInitialValue(inputValue, target) {
    const value = inputValue.toLowerCase();
    CF.customerReady(
      function () {
        target.checked = this.interests.includes(value);
      }.bind(this)
    );
  },

  setValue(inputValue, checked) {
    const value = inputValue.toLowerCase();

    if (!checked) {
      this.interests.splice(this.interests.indexOf(value), 1);
    } else {
      this.interests.push(value);
    }

    const event = new CustomEvent("interests-updated", {
      detail: { interests: this.interests, id: this.customerId },
    });
    document.dispatchEvent(event);
  },

  setClickValue(inputValue, id) {
    const value = inputValue.toLowerCase();
    if (this.interests.includes(value)) {
      this.interests.splice(this.interests.indexOf(value), 1);
    } else {
      this.interests.push(value);
    }

    const event = new CustomEvent("interests-updated", {
      detail: { interests: this.interests, id: this.customerId },
    });
    document.dispatchEvent(event);

    const checkbox = document.getElementById(id);
    checkbox.checked = !checkbox.checked;
  },
});
